import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Cartão de Crédito',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Transferência bancária',
    [PaymentMethod.SepaDebit]: 'EC-Card / IBAN',
    [PaymentMethod.Cash]: 'Dinheiro',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Outro método de pagamento',
  },
};
